import styled from 'styled-components';

export const Container = styled.div`
  padding: 10px;
`;

export const Buttons = styled.div`
  display: flex;
  margin-top: 10px;
  justify-content: space-between;
`;

export const CheckboxList = styled.ul`
  padding-left: 0;

  li {
    list-style: none;
  }
`;
